import { gql } from "@apollo/client";

const DELETE_RANKING_POINT_BLOCKS = gql`
  mutation removeRankingPoints($ids: [Int!]!) {
    removeRankingPoints(ids: $ids)
  }
`;

export default DELETE_RANKING_POINT_BLOCKS;
